<div class="multiInputOuterWrapper"
     [commonKeyboardList]="isOpen$ | async"
     commonKeyboardListNavArrow
     commonKeyboardListNavTab
     (keydown.escape)="isOpen$.next(false);"
     (commonKeyboardListThresholdTop)="onKeyboardBlur()"
     onmouseover="this.title = ''">
    <div class="multiInputWrapper {{fluentClass}}" [ngClass]="{'wTooltip':hasTooltip()}">
        <ul class="multiInputList {{modifiedClass}}"
            [ngClass]="{disabled: disabled, 'show-items': (isOpen$ | async)}">
            <li *ngFor="let item of items" class="multiInputItem">
                <div class="innerMultiInputItem" [ngClass]="{'hasCheckbox':isCheckbox()}">
                    <common-form-input *ngIf="isCheckbox()"
                                       type="checkbox" ngDefaultControl
                                       [disabled]="disabled"
                                       [label]=""
                                       [labelTitle]="checkboxLabelTitle"
                                       [(ngModel)]="item[checkbox]"></common-form-input>
                    <div class="itemText" [title]=getTitle(item) [id]=getId(item)>{{getValue(item)}}</div>

                    <div class="itemClose">
                        <a *ngIf="!disabled" href="javascript:" title="Entfernen"
                           (keydown.space)="removeItem($event, item)"
                           (click)="removeItem($event, item)">
                            <span class="icon-shut"></span>
                        </a>
                    </div>
                </div>
            </li>
            <li class="cursorFieldItem">
                <div class="cursorFieldContainer" *ngIf="!disabled">
                    <span class="icon-edit"></span>
                    <input class="inputField cursorField"
                           type="text"
                           value=""
                           autocomplete="off"
                           #searchInput
                           [disabled]="disabled"
                           (keydown.arrowDown)="showIfNot()"
                           (input)="onInput($event.target.value)"/>
                </div>
            </li>
        </ul>
        <div class="multiInputChoiceWrapper" *ngIf="isOpen$ | async">
            <ul class="multiInputChoice">
                <li class="choiceItem"
                    *ngFor="let selectableItem of filteredItems"
                    [title]="getTitle(selectableItem)"
                    commonKeyboardItem
                    (click)="selectItem(selectableItem)"
                    (keydown.enter)="selectItem(selectableItem)">{{getValue(selectableItem)}}
                </li>
            </ul>
        </div>
    </div>
    <common-form-input-tooltip *ngIf="dataToolTip" [value]="dataToolTip"></common-form-input-tooltip>
</div>


